import type { FC } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { formatNumberWithComa } from "app/pages/sales-intelligence/utils/leads";

type QuotaProps = {
    remainingWebsitesQuota: number;
    remainingContactsQuota: number;
};

const EnrichmentQuota: FC<QuotaProps> = ({ remainingWebsitesQuota, remainingContactsQuota }) => {
    return (
        <Flex
            alignItems="center"
            gap="16px"
        >
            <Text
                fontVariant="input2"
                color={colorsPalettes.carbon[300]}
            >
                {translate("si.enrichment.websites.quota.text")} <b>{formatNumberWithComa(remainingWebsitesQuota)}</b>
            </Text>
            <Text
                fontVariant="input2"
                color={colorsPalettes.carbon[300]}
            >
                {translate("si.enrichment.contacts.quota.text")} <b>{formatNumberWithComa(remainingContactsQuota)}</b>
            </Text>
        </Flex>
    );
};

export default EnrichmentQuota;
